import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Question } from './question';
import { BadInputError, Result, UniqueEntityID } from '@digibricks/core';
import { Answer } from '../answer';
import { FillInBlankCorrectAnswer } from '../correct-answers';
import { QuestionType } from '../question-type';
import { Score } from '../score';
import { SingleChoiceQuestion } from './single-choice-question';
import { MultipleChoiceQuestion } from './multiple-choice-question';
import { EssayQuestion } from './essay-question';
import { MatchingQuestion } from './matching-question';
import { SpeakingQuestion } from './speaking-question';
export var FillInBlankQuestion = /*#__PURE__*/function (_Question) {
  _inherits(FillInBlankQuestion, _Question);

  var _super = _createSuper(FillInBlankQuestion);

  function FillInBlankQuestion() {
    _classCallCheck(this, FillInBlankQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(FillInBlankQuestion, [{
    key: "answers",
    get: function get() {
      return this.props.answers;
    }
  }, {
    key: "correctAnswers",
    get: function get() {
      return this.props.correctAnswers;
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps, defaultDescription) {
      switch (newQuestionProps.type) {
        case QuestionType.SingleChoice:
          return SingleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.MultipleChoice:
          return MultipleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.Essay:
          return EssayQuestion.create(newQuestionProps);

        case QuestionType.Speaking:
          return SpeakingQuestion.createDefault(newQuestionProps);

        case QuestionType.Matching:
          {
            return MatchingQuestion.createDefault(newQuestionProps);
          }

        case QuestionType.FillInBlank:
          {
            var fillInBlankQuestion = question;
            var answers = fillInBlankQuestion.answers,
                correctAnswers = fillInBlankQuestion.correctAnswers;
            var fillInBlankQuestionProps = newQuestionProps;
            fillInBlankQuestionProps.answers = answers.map(function (a) {
              return Answer.create({
                id: a.id.toString(),
                description: a.description || defaultDescription
              }).getValue();
            });
            fillInBlankQuestionProps.correctAnswers = correctAnswers.map(function (a) {
              return FillInBlankCorrectAnswer.create({
                answerId: a.answerId,
                score: Score.create(a.score).getValue()
              }).getValue();
            });
            fillInBlankQuestionProps.score = Score.create(this.correctAnswers.reduce(function (a, b) {
              return a + b.score;
            }, 0)).getValue();
            return FillInBlankQuestion.create(fillInBlankQuestionProps);
          }
      }
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(FillInBlankQuestion.prototype), "toJsonObject", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        })
      });
    }
  }, {
    key: "addNewAnswer",
    value: function addNewAnswer(answer) {
      if (!answer) {
        return new BadInputError('Answer cannot be null');
      }

      this.props.answers = [].concat(_toConsumableArray(this.props.answers), [answer]);
      var correctAnswer = FillInBlankCorrectAnswer.create({
        score: Score.create(0.5).getValue(),
        answerId: answer.id.toString()
      });
      this.props.score = Score.create(this.props.score.value + correctAnswer.getValue().score).getValue();
      this.props.correctAnswers.push(correctAnswer.getValue());
      this.props.nextIndex = this.props.nextIndex + 1;
      return Result.ok();
    }
  }, {
    key: "addNewCorrectAnswer",
    value: function addNewCorrectAnswer(correctAnswers) {
      this.props.correctAnswers = [].concat(_toConsumableArray(this.props.correctAnswers), [correctAnswers]);
      return Result.ok();
    } // TODO: Will remove this after refactor question.

  }, {
    key: "updateAnswerDescription",
    value: function updateAnswerDescription(answerId, description) {
      this.props.answers = _toConsumableArray(this.props.answers).map(function (answer) {
        if (answer.id.toString() === answerId) {
          answer.updateDescription(description);
        }

        return answer;
      });
      return Result.ok();
    }
  }, {
    key: "updateAnswer",
    value: function updateAnswer(answer) {
      this.props.answers.splice(this.props.answers.indexOf(answer), 1, answer);
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswer",
    value: function updateCorrectAnswer(_ref) {
      var answerId = _ref.answerId,
          score = _ref.score;
      this.props.correctAnswers = _toConsumableArray(this.props.correctAnswers).map(function (correctAnswer) {
        if (correctAnswer.id.toString() === answerId) {
          correctAnswer.updateScore(score !== null && score !== void 0 ? score : 0);
        }

        return correctAnswer;
      });
      return Result.ok();
    }
  }, {
    key: "deleteAnswer",
    value: function deleteAnswer(answerId) {
      this.props.answers = this.props.answers.filter(function (answer) {
        return answer.id.toString() !== answerId;
      });
      this.props.correctAnswers = this.props.correctAnswers.filter(function (correctAnswer) {
        return correctAnswer.answerId !== answerId;
      });
      this.props.score = Score.create(this.props.correctAnswers.map(function (correctAnswer) {
        return correctAnswer.score;
      }).reduce(function (a, b) {
        return a + b;
      }, 0)).getValue();
      this.props.nextIndex = this.props.nextIndex - 1 > 0 ? this.props.nextIndex - 1 : 1;
      return Result.ok();
    }
  }, {
    key: "updateCorrectAnswers",
    value: function updateCorrectAnswers(correctAnswers) {
      var answerIds = correctAnswers.map(function (ca) {
        return ca.answerId;
      });
      var isNotValidAnswers = this.answers.filter(function (a) {
        return answerIds.includes(a.id.toString());
      }).length !== answerIds.length;

      if (isNotValidAnswers) {
        return new BadInputError('The Correct answers are not existed in answers');
      }

      this.props.correctAnswers = correctAnswers;
      return Result.ok();
    }
  }, {
    key: "updateAnswers",
    value: function updateAnswers(answers) {
      this.props.answers = answers;
      return Result.ok();
    }
  }, {
    key: "toJsonV2",
    value: function toJsonV2() {
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(FillInBlankQuestion.prototype), "toBaseJson", this).call(this)), {}, {
        answers: this.answers.map(function (a) {
          return a.toJsonObject();
        }),
        correctAnswers: this.correctAnswers.map(function (a) {
          return a.toJsonObject();
        })
      });
    }
  }], [{
    key: "create",
    value: function create(props) {
      var basePropsOrError = _get(_getPrototypeOf(FillInBlankQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var resultOrError = this.validate(props);

      if (resultOrError.isFailure) {
        return Result.fail(resultOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), props), {}, {
        type: QuestionType.FillInBlank
      });

      return Result.ok(new FillInBlankQuestion(defaultProps, new UniqueEntityID(props.id)));
    }
  }, {
    key: "createDefault",
    value: function createDefault(props) {
      var basePropsOrError = _get(_getPrototypeOf(FillInBlankQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      } // Don't create default answer - user will add blanks manually via text editor


      var answers = [];
      var correctAnswers = [];
      return FillInBlankQuestion.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        answers: answers,
        correctAnswers: correctAnswers
      }));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var answers = data.answers,
            correctAnswers = data.correctAnswers;

        var basePropsOrError = _get(_getPrototypeOf(FillInBlankQuestion), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var answerResultCombine = answers.map(function (a) {
          return Answer.fromJson(a);
        });
        var answerPropsOrError = Result.combineArray(answerResultCombine);

        if (answerPropsOrError.isFailure) {
          return Result.fail(answerPropsOrError.error);
        }

        var correctAnswerProps = correctAnswers ? correctAnswers.map(function (c) {
          return FillInBlankCorrectAnswer.create({
            id: c.id,
            answerId: c.answerId,
            score: Score.create(c.score).getValue(),
            index: c.index
          }).getValue();
        }) : [];
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          type: QuestionType.FillInBlank,
          answers: answerPropsOrError.getValue(),
          correctAnswers: correctAnswerProps
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "getCorrectAnswers",
    value: function getCorrectAnswers(question) {
      var correctAnswers = question.correctAnswers.map(function (c) {
        return {
          id: c.id.toString(),
          answerDescription: question.answers.find(function (a) {
            return a.id.toString() === c.answerId;
          }).description,
          answerId: c.answerId,
          answerScore: c.score,
          index: c.index
        };
      });
      return correctAnswers;
    }
  }]);

  return FillInBlankQuestion;
}(Question);